import config from "../branding/default/js/config";

const initialState = {
  loading: true,
  user_loading: true,
  user: {
    AM_ENABLED: "0",
    AM_MESSAGE: "",
    WEB_CHAT_LAYOUT: config.webchatlayout,
    WEB_ONEBOX_TEXT_BACKGROUND_COLOR: "white",
    WEB_ONEBOX_TEXT_COLOR: "black",
    WEB_TEXTAREA_IN_BACKGROUND:
      config.fonts.fontcolors_default_rectextbackground,
    WEB_TEXTAREA_OUT_BACKGROUND:
      config.fonts.fontcolors_default_senttextbackground,
    WEB_TEXT_IN_COLOR: config.fonts.fontcolors_default_rectextforeground,
    WEB_TEXT_OUT_COLOR: config.fonts.fontcolors_default_senttextforeground,
    WEB_TEXT_SIZE: config.fonts.fontsizes_default,
    WEB_RINGTONE: config.fonts.ringsignals_default,
    WEB_FONT: config.fonts.fonts_default,
    WEB_AUDIO: "true",
    WEB_VIDEO: "true",
  },
  system: {},
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SETTINGS_USER_LOADING":
      state = {
        ...state,
        user_loading: true,
      };
      break;
    case "SETTINGS_USER_LOADED":
      state = {
        ...state,
        user_loading: false,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
      break;
    case "SETTINGS_USER_LOADED_DEFAULT":
      state = {
        ...initialState,
        user_loading: false,
      };
      break;
    case "SETTINGS_SAVE":
      state = {
        ...state,
        settingsSaved: true,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
      break;
    case "SETTINGS_SAVED_RESET":
      state = {
        ...state,
        settingsSaved: false,
      };
      break;
    default:
      break;
  }

  state.loading = state.user_loading;

  return state;
};

export default settingReducer;






// WEBPACK FOOTER //
// ./src/reducers/settingReducer.js